import { gql } from "@apollo/client";

export const CREATE_PLAN_MUTATION = gql`
  mutation CreatePlan($input: CreatePlanInput!) {
    createPlan(input: $input) {
      id
      name
      description
      amount
      currency
      interval
      interval_count
      features
      limits
      is_default
      prorata_amount
      active
      stripe_product_id
      stripe_price_id
      created_at
      updated_at
    }
  }
`;

export const UPDATE_PLAN_MUTATION = gql`
  mutation UpdatePlan($input: UpdatePlanInput!) {
    updatePlan(input: $input) {
      id
      name
      description
      amount
      currency
      interval
      interval_count
      features
      limits
      active
      is_default
      prorata_amount
      stripe_product_id
      stripe_price_id
      updated_at
    }
  }
`;

export const DELETE_PLAN_MUTATION = gql`
    mutation DeletePlan($input: DeletePlanInput!) {
        deletePlan(input: $input) {
            success
            message
        }
    }
`;

// Create Company Plan Mutation

// Generate Upload URL Mutation
